<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                             Frequent Flyer Login Watcher                             │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->

<template>
    <div v-if="sessionExpiring && !suppressWarning" class="session-timeout-warning">
        <template v-if="sessionMinutesRemaining >= 1/60">
            <span>Your member login session will expire in {{ sessionTimeout }}</span>

            <button @click="suppressWarning = true">Ok</button>
            <button @click="continueSession">Continue session</button>
        </template>
        <template v-else>
            <span>Session expired</span>

            <button @click="$emit('log-in')">Log in</button>
        </template>
    </div>
</template>

<style>
    .session-timeout-warning {
        position: fixed;
        background: #fdffd1;
        border: 2px solid rgba(0 0 0 / 50%);
        padding: 1rem;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-evenly;
        left: 25%;
        right: 25%;
        top: 25%;
        bottom: 25%;
        max-height: 10em;
        z-index: 500;
        border-radius: 1em;
        box-shadow: 0 0 1em -0.5em;
    }

        .session-timeout-warning span {
            flex: 1 0 100%;
            text-align: center;
            padding: 1vw;
            font-size: 1.25em;
        }
</style>

<script>
    export default {
        name: "FrequentFlyerLoginWatcher",
        emits: ['log-in', 'session-started', 'session-ended'],

        data() {
            return {
                memberSessionExpires: null,

                sessionMinutesRemaining: null,
                countdownMinutes: 3,

                sessionExpiring: false,
                suppressWarning: false,

                clockId: null,

                FFM_INFO: this.getCookie("FFM_INFO")
            }
        },

        mounted() {
            this.clockId = setInterval(this.checkSession, 1000)
        },

        computed: {
            sessionTimeout() {
                let time = this.sessionMinutesRemaining
                let minutes = `${Math.floor(time)} minutes`
                let seconds = `${Math.floor(time * 60) % 60} seconds`

                return (time <= 0) ? null : (time < 1) ? seconds : `${minutes}, ${seconds}`
            }
        },


        watch: {
            FFM_INFO: {
                handler(newVal, oldVal) {
                    if (!newVal != !oldVal)
                        this.$emit(newVal ? 'session-started' : 'session-ended')
                }
            }
        },

        methods: {
            getCookie(key) {
                let cookie = document.cookie.split('; ').map(c => c.split('=')).filter(a => a[0] == key)[0]
                if (cookie) {
                    let values = cookie.slice(1).join('=').split('&')

                    if (values.length == 1)
                        return values = values[0]
                    else
                        return Object.fromEntries(values.map(k => k.split('=')))
                }
            },

            checkSession() {
                let FFM_INFO = this.FFM_INFO = this.getCookie("FFM_INFO")

                if (!FFM_INFO) {
                    this.sessionExpiring = false
                }
                else if (!FFM_INFO.expires) {
                    this.memberSessionExpires = null
                    this.sessionExpiring = false
                }
                else {
                    this.memberSessionExpires = new Date(FFM_INFO.expires)

                    this.sessionMinutesRemaining = (this.memberSessionExpires - Date.now()) / 1000 / 60
                    this.sessionExpiring = (this.sessionMinutesRemaining < this.countdownMinutes)

                    if (this.sessionExpiring && FFM_INFO.keepAlive)
                        this.continueSession()
                }
            },

            continueSession() {
                this.suppressWarning = true //  immediately close the warning popup on button click
                setTimeout(() => this.suppressWarning = false, 2000)   //  ... but then allow the popup to reappear later

                this.$emit('session-continue')
            }
        }
    }
</script>

